export enum ScrollDirection {
    RIGHT = 'right',
    LEFT = 'left'
}
